import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { currentOpenChatSelector } from '../../../selectors';
import { TMessage, TOutcomingStatus } from '../../../types/messages';
import { TOpenedChat } from '../../../types/openedChats';

interface IUseMessageImagesParams {
  message: TMessage & { status: TOutcomingStatus };
  messageId: string;
}

export const useMessageImages = ({ message, messageId }: IUseMessageImagesParams) => {
  const currentChat = useSelector(currentOpenChatSelector);

  return useMemo(() => {
    const { pendingFiles } = currentChat || ({} as TOpenedChat);
    const blobFiles = pendingFiles?.[messageId]?.blobFiles || [];

    return {
      imageBlobFiles: blobFiles.filter(({ type }) => type === 'image'),
      imageFiles: message.files?.images,
    };
  }, [currentChat, messageId, message]);
};
